import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {

  constructor(
    private translateService: TranslateService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(this.addLanguage(request));
  }
  addLanguage(request: HttpRequest<unknown>) {
    const language = this.translateService.currentLang
    return request.clone({
      setHeaders: {
        'Accept-Language': language ? language : 'en',
      },
    })
  }
}
